import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../store'
import { getAPIUrl } from '../helper';
import { createSlice } from '@reduxjs/toolkit';

export interface Partner{
    id?: string,
    name: string,
    disabled: boolean,
}

export interface PartnerState {
    partnerInEdition: Partner | null
}

export const initialState: PartnerState = {
    partnerInEdition: null
}

export const partnerSlice = createSlice({
    name: 'partner',
    initialState,
    reducers: {
        setPartnerInEdition: (state, payload:{payload:Partner|null}) => {
            state.partnerInEdition= payload.payload;
        }
    }
});

export const partnerAPISlice = createApi({
    reducerPath: 'partnerAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: getAPIUrl(),
        prepareHeaders: (headers:Headers, { getState }) => {
            const token = (getState() as RootState).authentication.JWTaccess;
            if (token) {
                headers.set('authorization', `Bearer ${token}`)
            }
            return headers;
        }
    }),
    tagTypes: ['Partner'],
    endpoints: builder => ({
        getPartners: builder.query<{count: number, results: Partner[]}, void>({
            query: () => {
                return {
                    url:`/partners/`,
                }
            },
            providesTags: (result, error, args) =>
                result && result.count > 0
                    ? [...result.results.map(({ id}) => ({ type: 'Partner' as const, id})), 'Partner']
                    : ['Partner'],
        }),
        getPartner: builder.query<Partner, string>({
            query: id => {
                return {
                    url:`/partners/${id}/`,
                }
            },
            providesTags: (result, error, id) => [{ type: 'Partner', id}],
        }),
        createPartner: builder.mutation<Partner, Partial<Partner>>({
            query: body => {
                return {
                    url: `/partners/`,
                    method: 'POST',
                    body
                }
            },
            invalidatesTags: () => [{ type: 'Partner' }],
        }),
        updatePartner: builder.mutation<Partner, Partial<Partner> & Pick<Partner, 'id'>>({
            query: body => {
                return {
                    url: `/partners/${body.id}/`,
                    method: 'PATCH',
                    body
                }
            },
            invalidatesTags: () => [{ type: 'Partner' }],
        }),
        deletePartner: builder.mutation<void, string>({
            query: id=> {
                return {
                    url: `/partners/${id}/`,
                    method: 'DELETE'
                }
            },
            invalidatesTags: () => [{ type: 'Partner' }],
        }),
    })
})
export default partnerSlice.reducer;
export const { setPartnerInEdition } = partnerSlice.actions

// Export the auto-generated hooks
export const {
    useGetPartnersQuery,
    useGetPartnerQuery,
    useDeletePartnerMutation,
    useUpdatePartnerMutation,
    useCreatePartnerMutation,
} = partnerAPISlice;
